<template>
  <div>
    <v-dialog
      scrollable
      :value="show"
      :width="$store.state.common.largeDialogWidth"
      persistent
      lazy
      @input="(val) => $emit('update:show', val)"
    >
      <v-card>
        <v-card-title class="pb-0">
          <v-layout align-center>
            <v-layout
              align-center
              wrap
            >
              <div class="headline">
                {{ $t('gemaFreeChannelUsedDialogTitle') }}
              </div>
            </v-layout>
            <v-btn
              class="ml-auto mr-0 my-0"
              flat
              icon
              :title="$t('close')"
              @click="close()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <p class="subheading grey--text text--darken-3">
            {{ $t('gemaFreeChannelUsedDialogBody_1') }}
          </p>
          <p class="subheading grey--text text--darken-3">
            {{ $t('gemaFreeChannelUsedDialogBody_2') }}
          </p>
        </v-card-text>
        <v-card-actions class="pt-0 pb-3">
          <v-spacer />
          <v-btn
            large
            round
            color="msr"
            dark
            @click="close()"
          >
            {{ $t('understood') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {redirectToExternalUrl} from '@/utils';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    sepaFormUrl() {
      if (!this.$user) {
        return '';
      }
      return this.$userprofile.workspace.sepa_direct_debit_mandate_form_url;
    },
  },
  mounted() {
    // Allow opening this dialog via a global signal.
    this.$bus.$on('show-ask-for-sepa-direct-debit-mandate-dialog', () =>
      this.$emit('update:show', true)
    );
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/GemaFreeChannelUsedDialog.vue